import { createIcon } from "@chakra-ui/react";

const VeryUnHappy = createIcon({
  displayName: "VeryUnHappy",
  viewBox: "24 24 40 40",
  path: (
    <>
      <path d="M43.89 48.15a13.26 13.26 0 0 1 8.94 3.49 1 1 0 0 1-1.31 1.41 11.26 11.26 0 0 0-15.06-.18 1 1 0 1 1-1.27-1.44 13.12 13.12 0 0 1 8.7-3.28z" />
      <circle cx="44" cy="44" r="20" fill="currentColor" />
      <path d="M43.89 48.15a13.26 13.26 0 0 1 8.94 3.49 1 1 0 0 1-1.31 1.41 11.26 11.26 0 0 0-15.06-.18 1 1 0 1 1-1.27-1.44 13.12 13.12 0 0 1 8.7-3.28zM54.18 43.08H54l-4.18-1.22a.64.64 0 0 1-.11-1.19S53 39 53.93 38.45a.64.64 0 1 1 .6 1.13L51.72 41l2.64.77a.64.64 0 0 1-.18 1.26zM33.82 43.08a.64.64 0 0 1-.18-1.26l2.64-.82-2.82-1.47a.64.64 0 0 1 .6-1.13l4.22 2.2a.64.64 0 0 1-.11 1.19L34 43.05z" />
    </>
  )
});

export default VeryUnHappy;
